"use strict";
/**
 * 语言与方向。
 *
 * 语言列表在 P1 首发即冻结为四项（中/英/西/阿）。这里之所以把 `dir` 和语言绑在一起、
 * 而不是等到渲染层再判断，是因为 RTL 会影响布局契约：一旦某天新增 RTL 语言，
 * 所有用物理属性的组件都要返工。先声明方向，就不会有人写出只对 LTR 成立的代码。
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.LOCALE_TAG = exports.LOCALE_LABEL = exports.LOCALE_DIR = exports.DEFAULT_LOCALE = exports.LOCALES = void 0;
exports.isLocale = isLocale;
exports.dirOf = dirOf;
exports.stripLocalePrefix = stripLocalePrefix;
exports.withLocalePrefix = withLocalePrefix;
exports.LOCALES = ['zh', 'en', 'es', 'ar'];
exports.DEFAULT_LOCALE = 'en';
exports.LOCALE_DIR = {
    zh: 'ltr',
    en: 'ltr',
    es: 'ltr',
    ar: 'rtl',
};
exports.LOCALE_LABEL = {
    zh: '简体中文',
    en: 'English',
    es: 'Español',
    ar: 'العربية',
};
/** BCP 47 标签，用于 <html lang> 与 hreflang */
exports.LOCALE_TAG = {
    zh: 'zh-Hans',
    en: 'en',
    es: 'es',
    ar: 'ar',
};
function isLocale(value) {
    return exports.LOCALES.includes(value);
}
function dirOf(locale) {
    return exports.LOCALE_DIR[locale];
}
/**
 * 从路径中剥离语言前缀。
 * 约定：默认语言不带前缀（/products），非默认语言带前缀（/es/products）。
 * 这样默认语言的 URL 最短，也避免 x-default 与默认语言重复。
 */
function stripLocalePrefix(pathname, defaultLocale = exports.DEFAULT_LOCALE) {
    const clean = pathname.startsWith('/') ? pathname : `/${pathname}`;
    const [, first = '', ...rest] = clean.split('/');
    if (isLocale(first) && first !== defaultLocale) {
        const path = `/${rest.join('/')}`.replace(/\/+$/, '') || '/';
        return { locale: first, path };
    }
    return { locale: defaultLocale, path: clean.replace(/\/+$/, '') || '/' };
}
/** 反向：给定语言与路径，生成该语言的规范 URL 路径 */
function withLocalePrefix(path, locale, defaultLocale = exports.DEFAULT_LOCALE) {
    const clean = path.startsWith('/') ? path : `/${path}`;
    return locale === defaultLocale ? clean : `/${locale}${clean === '/' ? '' : clean}`;
}
//# sourceMappingURL=locale.js.map